import * as modal from '../reducers/modalReducer';

export const SMALL_MODAL = 'SMALL_MODAL';
export const EMAIL_CONFIRMATION_MODAL = 'EMAIL_CONFIRMATION_MODAL';
export const EMAIL_UPDATE_FORM = 'EMAIL_UPDATE_FORM';

export const openSmallModal = modalProps => (dispatch) => {
  dispatch(modal.openModal({
    modalType: SMALL_MODAL,
    modalProps,
  }));
};

export const openEmailConfirmationModal = modalProps => (
  modal.openModal({
    modalType: EMAIL_CONFIRMATION_MODAL,
    modalProps,
  })
);

export const openEmailUpdateForm = modalProps => (
  modal.openModal({
    modalType: EMAIL_UPDATE_FORM,
    modalProps,
  })
);



// WEBPACK FOOTER //
// ./src/actions/modal.js